import { i18n } from '../../i18n';




export const filterColumnsHash = {
  desc_cont: {
    label: i18n.t('application.desc'),
    renderCell: {
      component: 'input'
    }
  },
  name_cont: {
    label: i18n.t('application.name'),
    renderCell: {
      component: 'input'
    }
  },
  share_desc_cont: {
    label: i18n.t('application.shareDesc'),
    renderCell: {
      component: 'input'
    }
  },
  share_title_cont: {
    label: i18n.t('application.shareTitle'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('application.id'),
    width: 80,
  },
  desc: {
    label: i18n.t('application.desc'),
  },
  name: {
    label: i18n.t('application.name'),
  },
  share_desc: {
    label: i18n.t('application.shareDesc'),
  },
  share_title: {
    label: i18n.t('application.shareTitle'),
  },
  wechat_application_id: {
    label: i18n.t('application.wechatApplication'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.wechat_application) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'wechat_applications.show', params: { id: row.wechat_application_id } }}>{row.wechat_application.id}</bean-link>
    },
  },
  created_at: {
    label: i18n.t('application.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('application.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  logo: {
    label: i18n.t('application.logo'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  poster_image: {
    label: i18n.t('application.posterImage'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  share_image: {
    label: i18n.t('application.shareImage'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  desc: {
    label: i18n.t('application.desc'),
    renderCell: {
      component: 'input',
    },
  },
  name: {
    label: i18n.t('application.name'),
    renderCell: {
      component: 'input',
    },
  },
  share_desc: {
    label: i18n.t('application.shareDesc'),
    renderCell: {
      component: 'input',
    },
  },
  share_title: {
    label: i18n.t('application.shareTitle'),
    renderCell: {
      component: 'input',
    },
  },
  logo: {
    label: i18n.t('application.logo'),
    width: 120,
    renderCell: {
      component: 'upload',
    }
  },
  poster_image: {
    label: i18n.t('application.posterImage'),
    width: 120,
    renderCell: {
      component: 'upload',
    }
  },
  share_image: {
    label: i18n.t('application.shareImage'),
    width: 120,
    renderCell: {
      component: 'upload',
    }
  },
}
